/**
 * --- Maatwerk Flohpro: store categories for multiple 'homepages' with specific menu, accent color etc.  ---
 *
 * Store category via cart.attributes.flohpro_store_category (metaobject handle).
 * Liquid reads cart + shop metafields — no localStorage / no DOM/CSS overrides here.
 * Pattern matches cart attribute POST (cf. page-collection.js saveCollectionview).
 */
(function () {
  var syncScriptElement = document.getElementById('flohpro-store-category-sync');
  if (!syncScriptElement) return;

  var syncPayload;
  try {
    syncPayload = JSON.parse(syncScriptElement.textContent);
  } catch (error) {
    return;
  }

  var cartAttributesPayload = {};
  if (syncPayload.clear) {
    cartAttributesPayload.flohpro_store_category = '';
  } else if (syncPayload.setHandle) {
    cartAttributesPayload.flohpro_store_category = syncPayload.setHandle;
  } else {
    return;
  }

  fetch(routes.cart_update_url, {
    method: 'POST',
    body: JSON.stringify({ attributes: cartAttributesPayload }),
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      Accept: 'application/javascript'
    },
    keepalive: true
  }).catch(function () {});
})();
